import ApiCaller from './ApiCaller';
import baseAjaxConfig from './BaseAjaxConfig';

export const LOCK_IN_DATA_REQUEST = 'LOCK_IN_DATA_REQUEST';
export const LOCK_IN_DATA_SUCCESS = 'LOCK_IN_DATA_SUCCESS';
export const LOCK_IN_DATA_ERROR = 'LOCK_IN_DATA_ERROR';
export const LOCK_IN_REGISTER_ERROR = 'LOCK_IN_REGISTER_ERROR';

export function lockInPageDetailsRequestAction() {
	return { type: LOCK_IN_DATA_REQUEST };
}

export function lockInPageDetailsSuccessAction(data) {
	return { type: LOCK_IN_DATA_SUCCESS, data };
}

export function lockInPageDetailsErrorAction(error) {
	return { type: LOCK_IN_DATA_ERROR, error };
}

export function lockInRegisterErrorAction(error) {
	return { type: LOCK_IN_REGISTER_ERROR, error };
}

export function lockInPageDetailsAction() {
	return dispatch => {
		dispatch(lockInPageDetailsRequestAction());
		return ApiCaller.get(
			Object.assign({}, baseAjaxConfig, {
				pathname: `/api/1/lockin/details`,
				acceptErrors: true
			})
		).then(
			data => dispatch(lockInPageDetailsSuccessAction(data['RESPONSE'])),
			err => {
				dispatch(lockInPageDetailsErrorAction(err));
				return Promise.reject(err['RESPONSE'] || err);
			}
		);
	};
}

export function lockInRegisterAction(_body) {
	return dispatch => {
		dispatch(lockInPageDetailsRequestAction());
		return ApiCaller.post(
			Object.assign({}, baseAjaxConfig, {
				pathname: `/api/1/lockin/action`,
				acceptErrors: true
			}),
			_body
		).then(
			data => dispatch(lockInPageDetailsSuccessAction(data['RESPONSE'].userLockinDetails)),
			err => {
				dispatch(lockInRegisterErrorAction(err));
				return Promise.reject(err['RESPONSE'] || err);
			}
		);
	};
}
